<template>
  <CrudDataTable
    :con="con"
    :items="filteredItems"
    :sortBy="sortBy"
    ref="dataTable"
    >
    <template v-slot:owner-name v-if="desk">{{ ownerName + " :" }}</template>
    <template v-slot:dialog-form="{ item }">
      <EditDeskSlotForm
        :con="con"
        :editedItem="item"
        @closed="closeEditDialog"
      />
    </template>
  </CrudDataTable>
</template>

<script>
import CrudDataTable from "../CrudDataTable";
import EditDeskSlotForm from "./EditDeskSlotForm";
import { mapGetters, mapActions } from "vuex";
import CrudDeskSlotsTable from "@/models/crud/CrudDeskSlotsTable";

export default {
  name: "CrudDeskSlots",
  components: {
    CrudDataTable,
    EditDeskSlotForm,
  },
  props: {
    center: null,
    room: null,
    deskSlots: null,
    desk: null,
  },
  data() {
    return {
      newDeskSlot: {},
    };
  },
  computed: {
    ...mapGetters("deskSlotModule", {
      deskSlotsByDeskId: "getDeskSlotsByDeskId",
    }),
    ownerName(){
      return this.room.name + " - "+this.desk.name  ;
    },
    con() {
      const _con = {
        ...CrudDeskSlotsTable,
        crud: {
          indexOf: (item) => {
            return this.deskSlots.indexOf(item);
          },
          create: (item) => {
            item.deskId = this.desk.id;
            return this.addDeskSlot(item);
          },
          update: (item) => {
            return this.editDeskSlot(item);
          },
          delete: (item) => {
            return this.deleteDeskSlot(item);
          },
        },
      };
      return _con;
    },
    filteredItems() {
      if (!this.desk) return this.deskSlots;
      return this.deskSlotsByDeskId(this.desk.id);
    },
    sortBy() {
      return this.desk ? "name" : "desk.room.name";
    },
  },
  methods: {
    ...mapActions("deskSlotModule", [
      "addDeskSlot",
      "editDeskSlot",
      "deleteDeskSlot",
    ]),

    closeEditDialog() {
      this.$refs.dataTable.closeEdit();
    },
  },
};
</script>
